import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { useEffect } from 'react';
import { ProductsGrid } from '@ui/product/products-grid.tsx';
import { usePopularProducts } from '@features/main/use-popular-product.ts';
import { BreadcrumbItem, Breadcrumbs } from '@heroui/react';
import { Home2 } from 'iconsax-react';

export const PopularPage = () => {
  const set = useNavbar();
  const { data } = usePopularProducts();

  useEffect(() => {
    set.popupar();
  }, []);

  return (
    <>
     <div className="lg:hidden">
       <ProductsGrid items={data} />
     </div>

      <div className="hidden lg:flex flex-col container max-w-7xl mx-auto pb-24 pt-12">
        <Breadcrumbs>
          <BreadcrumbItem href="/">
            <Home2 size="24" color="#9CA5AC" />
          </BreadcrumbItem>
          <BreadcrumbItem color="primary">
            Популярные товары
          </BreadcrumbItem>
        </Breadcrumbs>

        <div className="mt-6">
          <h1 className="text-4xl text-[#222222] font-bold">
            Популярные товары
          </h1>
        </div>

        <div className="mt-9">
          <ProductsGrid items={data} />
        </div>
      </div>
    </>
  );
};
